import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKeys } from '../react-query-config'
import { deleteUser } from '../user-management'

// Delete user hook
export const useDeleteUser = () => {
  const queryClient = useQueryClient()

  return useMutation<
    { userId: string; email: string; status: string; deletedAt: string; message: string },
    Error,
    string
  >({
    mutationFn: deleteUser,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.quota.tenantSummary() })
    },
  })
}
